import {Component, inject, OnInit} from "@angular/core";
import {AnalyticsService, AuthService} from "@kwsoft/otcx-core";

@Component({
    selector: "otcx-root",
    templateUrl: "./app.component.html",
    standalone: false
})
export class AppComponent implements OnInit {
    private readonly authService = inject(AuthService);
    readonly analyticsService = inject(AnalyticsService);

    constructor() {
        this.analyticsService.startTracking();
    }

    ngOnInit(): void {
        this.authService.initAuthService();
    }
}
